"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.configureAngular = void 0;
var angular_1 = __importDefault(require("angular"));
var actions_directive_1 = require("../js/actions.directive");
var activeRealmFilter_1 = require("../js/activeRealmFilter");
var config_1 = require("../js/config");
var encodeUriFilter_1 = __importDefault(require("../js/encodeUriFilter"));
var entity_severity_directive_1 = require("../js/entity.severity.directive");
var completionLabels_directive_1 = require("../js/completionLabels.directive");
var itemcode_component_1 = __importDefault(require("../js/itemcode.component"));
var kebabFilter_1 = __importDefault(require("../js/kebabFilter"));
var list_service_1 = require("../js/list.service");
var person_service_1 = require("../js/person.service");
var person16_service_1 = require("../js/person16.service");
var split_service_1 = require("../js/split.service");
var timelineDirective_1 = __importDefault(require("./timelineDirective"));
var outlineBodyDirective_1 = __importDefault(require("./outlineBodyDirective"));
var outlineBodyViewDirective_1 = require("./outlineBodyViewDirective");
var AudRoamCtrl_1 = require("./AudRoamCtrl");
var authInterceptor_1 = require("./services/authInterceptor");
var searchService_1 = require("./services/searchService");
var scheduleService_1 = require("./services/scheduleService");
var tallyService_1 = require("./services/tallyService");
var timeCalculationService_1 = require("./services/timeCalculationService");
var encryptionService_1 = require("./services/encryptionService");
var historyService_1 = require("./services/historyService");
var resultRowDraftService_1 = require("./services/resultRowDraftService");
var offlineDataService_1 = require("./services/offlineDataService");
var pilotNotesSyncService_1 = require("./services/pilotNotesSyncService");
var threadsApiService_1 = require("./services/threadsApiService");
var appEventsService_1 = require("./services/appEventsService");
var notificationService_1 = require("./services/notificationService");
var pushSubscriptionService_1 = require("./services/pushSubscriptionService");
var pwaService_1 = require("./services/pwaService");
var configureAngular = function () {
    angular_1.default.module('app.config', []).value('app.config', config_1.appConfig);
    angular_1.default
        .module('audRoamApp', [
        'app.config',
        'ui.bootstrap',
        'chart.js',
        //'ngMap',
        'angularMoment',
        timelineDirective_1.default,
        outlineBodyDirective_1.default,
        outlineBodyViewDirective_1.outlineBodyViewModule.name,
    ])
        .config([
        '$compileProvider',
        '$httpProvider',
        function ($compileProvider, $httpProvider) {
            $compileProvider.debugInfoEnabled(false);
            // $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|file|inshort|ithoughts):/);
            $compileProvider.aHrefSanitizationWhitelist(/^(https?|mailto):/);
            // Add HTTP interceptor for automatic token refresh
            $httpProvider.interceptors.push('authInterceptor');
        },
    ])
        .filter('kebab', kebabFilter_1.default)
        .filter('encodeUri', encodeUriFilter_1.default)
        .filter('activeRealm', activeRealmFilter_1.activeRealmFilterFactory)
        .directive('adrActions', actions_directive_1.adrActionsFactory)
        .directive('adrEntitySeverity', entity_severity_directive_1.adrEntitySeverityFactory)
        .directive('adrCompletionLabels', completionLabels_directive_1.adrCompletionLabelsFactory)
        .component('adrItemCode', itemcode_component_1.default)
        .factory('listService', list_service_1.listServiceFactory)
        .factory('personService', person_service_1.personServiceFactory)
        .factory('person16Service', person16_service_1.person16ServiceFactory)
        .factory('splitService', split_service_1.splitServiceFactory)
        .factory('authInterceptor', authInterceptor_1.authInterceptor)
        .factory('searchService', searchService_1.SearchServiceFactory)
        .factory('scheduleService', scheduleService_1.scheduleServiceFactory)
        .factory('timeCalculationService', timeCalculationService_1.timeCalculationServiceFactory)
        .factory('tallyService', tallyService_1.tallyService)
        .factory('encryptionService', function () { return new encryptionService_1.EncryptionService(); })
        .factory('historyService', historyService_1.HistoryServiceFactory)
        .factory('resultRowDraftService', resultRowDraftService_1.resultRowDraftServiceFactory)
        .factory('offlineDataService', offlineDataService_1.offlineDataServiceFactory)
        .factory('pilotNotesSyncService', pilotNotesSyncService_1.pilotNotesSyncServiceFactory)
        .factory('threadsApiService', threadsApiService_1.threadsApiServiceFactory)
        .factory('appEventsService', appEventsService_1.appEventsServiceFactory)
        .factory('notificationService', notificationService_1.notificationServiceFactory)
        .factory('pushSubscriptionService', pushSubscriptionService_1.pushSubscriptionServiceFactory)
        .factory('pwaService', pwaService_1.pwaServiceFactory)
        .controller('AudRoamCtrl', [
        '$scope',
        '$rootScope',
        '$window',
        '$http',
        '$interval',
        '$timeout',
        '$q',
        'personService',
        'person16Service',
        'listService',
        'splitService',
        'app.config',
        'moment',
        'searchService',
        'scheduleService',
        'tallyService',
        'timeCalculationService',
        'encryptionService',
        'historyService',
        'pushSubscriptionService',
        'pwaService',
        'resultRowDraftService',
        'offlineDataService',
        'pilotNotesSyncService',
        'threadsApiService',
        'appEventsService',
        AudRoamCtrl_1.AudRoamCtrl,
    ]);
    // Register directives that expect the module to already exist
    // (avoid nomod by requiring after module creation)
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    require('../js/treeview.directive');
};
exports.configureAngular = configureAngular;
if (typeof angular_1.default !== 'undefined') {
    (0, exports.configureAngular)();
    // Manual bootstrap since ng-app is removed to allow configuration after script load
    angular_1.default.bootstrap(document, ['audRoamApp']);
}
